/** 回旋镖实体：绕身轨道，参数由控制器按等级 / 进化给出。 */

export interface Boomerang {
  angle: number;
  prevAngle: number;
  spin: number;
  prevSpin: number;
  x: number;
  y: number;
  prevX: number;
  prevY: number;
}

export function createBoomerang(index: number, total: number): Boomerang {
  const phase = (index / total) * Math.PI * 2;
  return {
    angle: phase, prevAngle: phase,
    spin: 0, prevSpin: 0,
    x: 0, y: 0, prevX: 0, prevY: 0,
  };
}

/** 数量变化后同步（新增的按当前均布相位插入）。 */
export function syncBoomerangs(list: Boomerang[], count: number): void {
  while (list.length < count) list.push(createBoomerang(list.length, count));
  while (list.length > count) list.pop();
}

interface PlaceOpts {
  px: number;
  py: number;
  radius: number;
  angularSpeed: number;
  spinSpeed: number;
  dt: number;
}

export function placeBoomerangs(list: readonly Boomerang[], o: PlaceOpts): void {
  const delta = o.angularSpeed * o.dt;
  for (const b of list) {
    b.prevAngle = b.angle;
    b.prevSpin = b.spin;
    b.angle += delta;
    b.spin += o.spinSpeed * o.dt;
    b.prevX = b.x;
    b.prevY = b.y;
    b.x = o.px + Math.cos(b.angle) * o.radius;
    b.y = o.py + Math.sin(b.angle) * o.radius;
  }
}
